/**
 * @file useSingleton Singleton mode
 */
import { useRef } from 'react';
export function useSingleton(creator) {
  var ref = useRef(null);
  var init = useRef(false);

  if (!init.current) {
    ref.current = creator();
    init.current = true;
  }

  return ref.current;
}